import React, { memo } from 'react';
import ClientDetailSingleton from './ClientDetailSingleton';
import ClientFormSingleton from './ClientFormSingleton';

const ClientPanel = memo(({ 
  selectedItem, 
  showForm, 
  handleUnselectItem, 
  handleEditItem, 
  handleDeleteItem, 
  handleDeleteConfirmation,
  handleClientAdd,
  setShowForm 
}) => {
  console.log('ClientPanel rendered with selectedItem:', selectedItem, 'showForm:', showForm);
  
  if (showForm) {
    return (
      <ClientFormSingleton
        editingItem={selectedItem}
        closeForm={() => {
          setShowForm(false);
          handleUnselectItem();
        }}
        onClientAdd={handleClientAdd}
      />
    );
  }

  return (
    <ClientDetailSingleton
      selectedItem={selectedItem}
      handleUnselectItem={handleUnselectItem}
      handleEditItem={() => setShowForm(true)}
      handleDeleteItem={() => handleDeleteConfirmation(selectedItem)}
    />
  );
});

ClientPanel.displayName = 'ClientPanel';

export default ClientPanel;
